import { PreviewPlanRequest } from "@client/requests";
import {
  SubscriptionPlanPreviewResource,
  subscriptionPlanPreviewResourceSchema,
} from "@client/resources/SubscriptionPlanPreviewResource";
import { APIMethods, ApiResponse } from "@typeDefinitions";
import { fetchData } from "@utils/api";
import { logFetchValidateError } from "@utils/validate";
import { object } from "yup";

export type PostCheckoutUpgradePreviewResponse =
  ApiResponse<SubscriptionPlanPreviewResource>;

const postCheckoutUpgradePreviewResponseSchema = object({
  data: subscriptionPlanPreviewResourceSchema.defined(),
});

export const postCheckoutUpgradePreview = async (
  payload: PreviewPlanRequest,
): Promise<PostCheckoutUpgradePreviewResponse> => {
  const response = await fetchData(
    "/dietitian/checkout/upgrade/preview",
    APIMethods.POST,
    payload,
  );

  return await postCheckoutUpgradePreviewResponseSchema
    .validate(response)
    .catch(logFetchValidateError("/dietitian/checkout/upgrade/preview"));
};
